import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Bell, Check, Archive, AlertTriangle } from "lucide-react";
import api, { fmtDate } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";

export default function Notifiche() {
  const { selectedStructure } = useAuth();
  const qc = useQueryClient();
  const nav = useNavigate();
  const { data = [] } = useQuery({ queryKey: ["notifiche", selectedStructure], queryFn: async () => (await api.get("/notifiche", { params: { structure_id: selectedStructure } })).data });

  const act = async (id, kind) => { await api.post(`/notifiche/${id}/${kind}`); qc.invalidateQueries({ queryKey: ["notifiche"] }); qc.invalidateQueries({ queryKey: ["stats"] }); };

  return (
    <div>
      <h1 className="text-2xl font-head font-bold mb-1">Notifiche e allerte</h1>
      <p className="text-sm text-muted-foreground mb-5">{data.filter((n) => !n.read).length} non lette</p>
      <div className="space-y-2 max-w-3xl">
        {data.length === 0 && <div className="gr-card p-10 text-center text-muted-foreground">Nessuna notifica</div>}
        {data.map((n) => (
          <div key={n.id} className={`gr-card p-4 flex items-start gap-3 ${!n.read ? "border-l-4" : "opacity-70"}`} style={!n.read ? { borderLeftColor: "#dc2626" } : {}} data-testid={`notif-${n.id}`}>
            <div className="h-9 w-9 rounded-lg grid place-items-center shrink-0" style={{ background: "#fee2e2", color: "#dc2626" }}><AlertTriangle size={18} /></div>
            <div className="flex-1 cursor-pointer" onClick={() => n.link && nav(n.link)}>
              <div className="font-semibold text-sm">{n.title}</div>
              <div className="text-sm text-muted-foreground">{n.message}</div>
              <div className="text-xs text-muted-foreground mt-1">{fmtDate(n.created_at)}</div>
            </div>
            <div className="flex gap-1">
              {!n.read && <Button size="sm" variant="ghost" onClick={() => act(n.id, "read")} data-testid={`read-${n.id}`}><Check size={15} /></Button>}
              <Button size="sm" variant="ghost" onClick={() => act(n.id, "archive")} data-testid={`archive-${n.id}`}><Archive size={15} /></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
